var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconServiceAnaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M21.6 20.823a5.275 5.275 0 0 0 .764-2.731 5.023 5.023 0 0 0-4.909-5.143 5.023 5.023 0 0 0-4.909 5.143 5.021 5.021 0 0 0 4.9 5.143 4.679 4.679 0 0 0 2.607-.8L23.451 26 25 24.377zm-4.145.126a2.86 2.86 0 1 1 2.727-2.857 2.8 2.8 0 0 1-2.731 2.857zm-.393-9.714a6.175 6.175 0 0 0-2.291.514l-.6-.949-4.145 7.063-3.288-4.023-3.96 6.64L1 19.143 6.455 10l3.273 4 4.364-7.429zm2.825.571a6.221 6.221 0 0 0-2.236-.56L23.233 2 25 3.349z",
    transform: "translate(-1 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceAnaly);
export default __webpack_public_path__ + "static/media/icon-service-analy.4306a2cd.svg";
export { ForwardRef as ReactComponent };